import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {DropdownFooter} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownFooter';

/*
 * Props.
 */

export interface FilterApplyFooterProps {
  onApplyClicked: () => void;
  onCancelClicked: () => void;
  onRequestClose?: () => void;
  applyButtonLabel?: ReactNode;
  isApplyDisabled?: boolean;
}

/*
 * Style.
 */

const StyledDropdownFooterContainerDiv = styled.div`
  display: flex;
  vertical-align: middle;
  flex-direction: row;
  justify-content: flex-end;
`;

const StyledApplyButton = styled(Button)`
  margin-left: 8px;
`;

const StyledDropdownFooter = styled(DropdownFooter)`
  position: sticky;
  align-self: flex-end;
  bottom: 0;
  width: 100%;
  background-color: ${(p) => p.theme.foreground};
`;

/*
 * Component.
 */

export const FilterApplyFooter: FC<FilterApplyFooterProps> = ({
  onApplyClicked,
  onCancelClicked,
  onRequestClose,
  applyButtonLabel,
  isApplyDisabled,
}) => {
  const applyClicked = () => {
    if (isApplyDisabled) {
      return;
    }

    onApplyClicked();
    if (onRequestClose) {
      onRequestClose();
    }
  };

  const cancelClicked = () => {
    onCancelClicked();
    if (onRequestClose) {
      onRequestClose();
    }
  };

  return (
    <StyledDropdownFooter>
      <StyledDropdownFooterContainerDiv>
        <Button variant={ButtonVariantsEnum.SECONDARY} isRounded onClick={cancelClicked}>
          <Trans id="filter-dropdown-cancel">Cancel</Trans>
        </Button>
        <StyledApplyButton
          variant={ButtonVariantsEnum.PRIMARY}
          isRounded
          onClick={applyClicked}
          isDisabled={isApplyDisabled}
        >
          {applyButtonLabel ?? <Trans id="filter-dropdown-apply">Apply</Trans>}
        </StyledApplyButton>
      </StyledDropdownFooterContainerDiv>
    </StyledDropdownFooter>
  );
};
